import { render, staticRenderFns } from "./PatientInfo.vue?vue&type=template&id=6067613b"
import script from "./PatientInfo.vue?vue&type=script&lang=js"
export * from "./PatientInfo.vue?vue&type=script&lang=js"
import style0 from "./PatientInfo.vue?vue&type=style&index=0&id=6067613b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports